export default "/images/vendor/flag-icon-css/flags/4x3/je.svg?7a0b4850d933dbc21d7544b015d878b7";